import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import prometnaLogo from "../Slike/prometnaLogo.png";
import { ReactComponent as MailIkona } from "../Slike/mailIkona.svg";
import { ReactComponent as KljucavnicaIkona } from "../Slike/kljucavnicaIkona.svg";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log("LOGIN RESPONSE:", data);

      setLoading(false);

      // ERROR
      if (!data.success) {
        if (data.inactive) {
          setError("Vaš račun je bil deaktiviran.");
        } else {
          setError(data.message || "Napaka pri prijavi");
        }
        return;
      }

      // RESET PASSWORD
      if (data.reset_required) {
        if (!data.token) {
          setError("Manjka reset token v bazi");
          return;
        }

        navigate(`/reset-password?token=${data.token}`);
        return;
      }

      // SUCCESS LOGIN
      if (data.success && data.user) {
        login(data.user);

        const role = data.user.role_id;

        if (role === 3) {
          navigate("/"); // ADMIN → dashboard (index route)
        } else if (role === 2) {
          navigate("/tickets"); // IKT
        } else {
          navigate("/CreateTicket"); // USER
        }

        return;
      }
    } catch (err) {
      setLoading(false);
      setError("Server error");
    }
  };

  console.log("API URL:", process.env.REACT_APP_API_URL);
  return (
    <div className="h-screen w-screen relative overflow-hidden bg-white">
      {/* BACKGROUND */}
      <div className="absolute inset-0 hidden md:flex">
        <div className="w-1/2 bg-midBlue" />
        <div className="w-1/2 bg-white" />
      </div>

      {/* CONTAINER */}
      <div className="absolute inset-0 flex items-center justify-center z-10 p-4">
        <div className="w-full h-full md:w-[85%] md:h-[80%] md:flex md:shadow-[0_15px_50px_rgba(0,0,0,0.4)] md:rounded-lg overflow-hidden">
          {/* LEFT */}
          <div className="hidden md:flex w-1/2 bg-midBlue flex-col items-center justify-center p-10 text-center">
            <h1 className="text-5xl font-bold text-white mb-6">
              Dobrodošli nazaj!
            </h1>
            <p className="text-xl font-bold text-white">
              Prometne poti puščajo sledi...
            </p>
            <p className="text-xl text-white mt-2">
              Že <span className="font-bold">64 let</span> delimo naše znanje.
            </p>
          </div>

          {/* RIGHT (TVOJ ORIGINAL DESIGN) */}
          <div className="flex-1 bg-white flex items-center justify-center p-6 md:p-10">
            <div className="flex flex-col items-center w-full max-w-sm">
              <img src={prometnaLogo} alt="logo" className="w-48 mb-6" />

              <form onSubmit={handleLogin} className="w-full flex flex-col">
                {/* EMAIL */}
                <label className="mb-2 text-sm">E-mail</label>
                <div className="flex items-center border border-midBlue rounded mb-4 overflow-hidden">
                  <div className="border-r border-midBlue p-3">
                    <MailIkona className="w-5 h-5 text-midBlue" />
                  </div>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="text"
                    className="flex-1 p-3 outline-none"
                    placeholder="Vnesi email"
                  />
                </div>

                {/* PASSWORD */}
                <label className="mb-2 text-sm">Geslo</label>
                <div className="flex items-center border border-midBlue rounded mb-4 overflow-hidden">
                  <div className="border-r border-midBlue p-3">
                    <KljucavnicaIkona className="w-5 h-5 text-midBlue" />
                  </div>
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    className="flex-1 p-3 outline-none"
                    placeholder="********"
                  />
                </div>

                {/* ERROR */}
                {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

                {/* BUTTON */}
                <button
                  type="submit"
                  className="bg-midBlue text-white font-bold py-3 rounded hover:opacity-90"
                >
                  {loading ? "Prijavljanje..." : "Prijavi se"}
                </button>
              </form>
              <p
                onClick={() => navigate("/forgot-password")}
                className="text-sm mt-3 text-right text-midBlue cursor-pointer hover:underline"
              >
                Pozabljeno geslo?
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
